import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteContactsData from './GetOrgUnitAthleteContactsData';
import postOrgUnitAthleteContactData from './PostOrgUnitAthleteContactData';
import putOrgUnitAthleteContactData from './PutOrgUnitAthleteContactData';
import deleteOrgUnitAthleteContactData from './DeleteOrgUnitAthleteContactData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OrgUnitAthleteContactData = {
  INITIAL_STATE, getOrgUnitAthleteContactsData, postOrgUnitAthleteContactData,
  putOrgUnitAthleteContactData, deleteOrgUnitAthleteContactData
};

export default OrgUnitAthleteContactData;